'use strict'

// Large workspace-app launcher card for the home page's BUILD group —
// the visually dominant cluster per the brief ("Build is the core
// identity, make it the headline"). Same data shape as AppCard but
// taller padding, bigger icon, stronger surface.
//
// Per-card state (fed by main.js's HOME_BUILD via childrenAs: 'state'):
//   { title, caption, icon, route, color? }
// `color` is unused for hover/border accent today — kept on the data so
// per-card tinting can be re-enabled without re-deriving the palette.
export const AppHeroCard = {
  tag: 'button',
  type: 'button',
  flow: 'y',
  gap: 'A',
  round: 'radiusSheet',
  padding: 'C',
  textAlign: 'left',
  cursor: 'pointer',
  color: 'title',
  background: 'overlay',
  border: 'none',
  transition: '160ms defaultBezier background, 160ms defaultBezier transform',
  ':hover': { theme: 'dialog', transform: 'translateY(-2px)' },

  onClick: (e, el, s) => {
    if (s.route) el.router(s.route, el.getRoot())
  },

  // Bigger icon than AppCard's bare-glyph treatment — sits in a small
  // tile so the Build cards have a focal point and stand apart from the
  // compact cluster items below.
  IconTile: {
    width: 'D',
    height: 'D',
    minWidth: 'D',
    round: 'radiusCard',
    align: 'center center',
    background: 'background',
    color: 'title',
    Icon: { name: (el, s) => s.icon, boxSize: 'C' }
  },

  Title: {
    tag: 'span',
    fontSize: 'B',
    fontWeight: '700',
    color: 'title',
    letterSpacing: '-0.005em',
    text: (el, s) => s.title
  },

  Caption: {
    tag: 'p',
    margin: '0',
    fontSize: 'A',
    lineHeight: '1.4',
    color: 'caption',
    text: (el, s) => s.caption
  }
}
